import { Link } from 'react-router-dom';
import { CLINIC } from '../data/clinic';
import { useLang } from '../i18n';
import { pathFor, conditionPath } from '../data/routes';
import { CONDITIONS_SEO, resolveCondition } from '../data/seo';

const LINK_KEYS = ['home', 'walkin', 'pi', 'services', 'decompression', 'programs', 'technology', 'contact'];

const Footer = () => {
  const { t, lang } = useLang();

  return (
    <footer data-testid="site-footer" style={{ background: '#EAE5DD' }}>
      <div className="mx-auto w-full max-w-[1280px] px-6 md:px-12 pt-16 pb-28 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="font-display" style={{ fontSize: '18px', fontWeight: 700 }}>{CLINIC.name.toUpperCase()}</div>
            <p className="mt-3 font-body" style={{ fontSize: '15px', color: '#8B817A', lineHeight: 1.7 }}>{t.footer.excellence}</p>
            <p className="mt-4 font-body" style={{ fontSize: '15px', color: '#8B817A', lineHeight: 1.7 }}>
              {CLINIC.addressLine1}<br />{CLINIC.addressLine2}
            </p>
            <a href={CLINIC.phoneHref} className="mt-4 inline-block font-display" style={{ fontSize: '20px', color: '#1B1815' }} data-testid="footer-phone">
              {CLINIC.phone}
            </a>
            <a href={CLINIC.emailHref} className="mt-2 block font-body transition-colors hover:text-terracotta" style={{ fontSize: '15px', color: '#8B817A', wordBreak: 'break-word' }} data-testid="footer-email">
              {CLINIC.email}
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {LINK_KEYS.map((key) => (
              <Link key={key} to={pathFor(key, lang)} className="font-body transition-colors hover:text-terracotta" style={{ fontSize: '15px', color: '#1B1815' }} data-testid={`footer-link-${key}`}>
                {t.nav[key]}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-body uppercase" style={{ fontSize: '13px', letterSpacing: '0.18em', color: '#A79E95' }}>{t.nav.conditions}</div>
            {CONDITIONS_SEO.slice(0, 10).map((base, i) => {
              const c = resolveCondition(base, lang);
              return (
                <Link key={base.slug} to={conditionPath(base.slug, base.es ? lang : 'en')} className="font-body transition-colors hover:text-terracotta" style={{ fontSize: '15px', color: '#1B1815' }} data-testid={`footer-condition-${i}`}>
                  {c.condition}
                </Link>
              );
            })}
            <Link to="/conditions" className="font-body transition-colors hover:text-terracotta" style={{ fontSize: '15px', color: '#1E4E8C', fontWeight: 600 }} data-testid="footer-all-conditions">
              View all conditions →
            </Link>
          </div>

          <div>
            <div className="font-display italic" style={{ fontSize: '20px', color: '#1B1815' }}>{t.footer.walkins}</div>
            <div className="mt-4 space-y-1">
              {t.schedule.rows.map((r) => (
                <div key={r.days} className="font-body" style={{ fontSize: '15px', color: '#8B817A' }}>
                  <span style={{ color: '#1B1815' }}>{r.days}</span> — {r.time}
                </div>
              ))}
              <div className="mt-3 font-body" style={{ fontSize: '13px', color: '#1E4E8C', lineHeight: 1.6 }}>{t.schedule.urgentNote}</div>
            </div>
            <div className="mt-6">
              <a href={CLINIC.bookingUrl} target="_blank" rel="noreferrer" className="btn-primary inline-flex" style={{ padding: '12px 24px', fontSize: '14px' }} data-testid="footer-book-btn">{t.nav.book}</a>
            </div>
          </div>
        </div>

        <div className="mt-10 h-px w-full" style={{ background: '#E6DFD4' }} />
        <p className="mt-6 text-center font-body" style={{ fontSize: '15px', color: '#A79E95' }}>
          © {new Date().getFullYear()} {CLINIC.name} · Austin, TX. {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
